import React, { useEffect, useRef } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import ProductShowcase from './components/ProductShowcase';
import ProductDetail from './components/ProductDetail';
import About from './components/About';
import Footer from './components/Footer';
import ImageCarousel from './components/ImageCarousel.js';
import './components/ImageCarousel.css';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/product/:id" element={<ProductDetail />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

function HomePage() {
  const carouselRef = useRef(null);
  const carouselInstance = useRef(null);

  useEffect(() => {
    // Initialize the vanilla JS carousel component
    if (carouselRef.current && !carouselInstance.current) {
      try {
        carouselInstance.current = new ImageCarousel(carouselRef.current);
      } catch (error) {
        console.error('Error initializing carousel:', error);
      }
    }

    // Cleanup on unmount
    return () => {
      if (carouselInstance.current && typeof carouselInstance.current.destroy === 'function') {
        carouselInstance.current.destroy();
      }
    };
  }, []);

  return (
    <>
      <section ref={carouselRef} className="carousel-container">
        {/* Carousel content will be dynamically generated by JavaScript */}
      </section>
      <Hero />
      <ProductShowcase />
      <About />
    </>
  );
}

export default App;